export default "__VITE_ASSET__ae45409f__"